/** The mark of GitLab in its own colour. The stroke icons live in the kit; a coloured
 * mark of a brand only Hammurapi needs stays here (FTR.NAB.CMN-0005 design §2). */
export function GitLabIcon() {
  return (
    <svg className="i" viewBox="0 0 24 24" aria-hidden="true">
      <path d="m12 21-9-7 2-9 3 7h8l3-7 2 9z" fill="#FC6D26" stroke="#FC6D26" />
    </svg>
  );
}
